import { GlobalConstants } from "./global-constants";

export const resourceTypeNameList: object[] = [
  { label: "TTSelfServeRole", value: "TTSelfServeRole" }
];
export const resourceNamespaceNameList: object[] = [
  { label: "MSTI", value: "MSTI" },
];

export const uiPageTypes = {
  can_view: [
    {
      label: "Download Reports",
      value: "changeTransitTimeActiveVersionId",
    },
    { label: "View History", value: "viewPreviousRequestId" },
  ],
  can_edit: [
    {
      label: "Update Transit Time",
      value: "updateTransitTimeRequestId",
    },
    {
      label: "Update Validation Threshold",
      value: "updateValidationThresholdId",
    },
    {
      label: "Add/Remove Overrides",
      value: "updateTransitTimeOverridesId",
    },
    {
      label: "Switch Transit Time Type",
      value: "changeTransitTimeConfigurationId",
    },
  ],
  can_review: [
    {
      label: "Pending Approval Requests",
      value: "pendingApprovalRequestsId",
    },
  ],
};

export const viewLabels = {
  can_view: "View",
  can_edit: "Edit",
  can_review: "Review",
  onboardingRequestId: "Onboarding request",
  otherRequest: "Other request",
};

export const viewLabelValues = {
  canView: "can_view",
  canEdit: "can_edit",
  canReview: "can_review",
  onboardingRequestId: "onboardingRequestId",
  otherRequest: "otherRequestAccessType",
};

export const uiPageTypeList = [
  { label: viewLabels.can_view, value: viewLabelValues.canView },
  { label: viewLabels.can_edit, value: viewLabelValues.canEdit },
  { label: viewLabels.can_review, value: viewLabelValues.canReview },
];

export const requestAccessTypeList: object[] = [
  {
    label: viewLabels.onboardingRequestId,
    value: viewLabelValues.onboardingRequestId,
  },
  { label: viewLabels.otherRequest, value: viewLabelValues.otherRequest },
];

export enum userConsentEnum {
  YES = "YES",
  NO = "NO",
  ALL = "ALL",
}

export const requestPermissionFormConstants = {
  requestAccessType: "requestAccessType",
  uiPageType: "uiPageType",
  fromCountryCode: GlobalConstants.FROM_COUNTRY_CODE,
  businessUseCase: GlobalConstants.BUSINESS_USE_CASE,
  componentKeyPlaceholder: GlobalConstants.COMPONENT_KEY_PLACE_HOLDER,
  componentKeyValue: GlobalConstants.COMPONENT_KEY_VALUE,
  transitTimeType: GlobalConstants.TRANSIT_TIME_TYPE,
  requestReason: "requestReason",
  componentKeyValueSelector: "componentKeyValueSelector",
};

export const uiPageTypeOperationGroupName = {
  changeTransitTimeActiveVersionId: viewLabelValues.canView,
  viewPreviousRequestId: viewLabelValues.canView,
  updateTransitTimeRequestId: viewLabelValues.canEdit,
  updateValidationThresholdId: viewLabelValues.canEdit,
  updateTransitTimeOverridesId: viewLabelValues.canEdit,
  changeTransitTimeConfigurationId: viewLabelValues.canEdit,
  pendingApprovalRequestsId: viewLabelValues.canReview,
};
